import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "./Loader";
import { clog } from "../lib/utils";

function SlackCallBackUrl() {
  const navigate = useNavigate();
  const [loading, setloading] = useState(true);
  const getSlackAccessToken = async (code, state) => {
    // clog(id);
    // let slack_access = JSON.parse(localStorage.getItem("slack_access") || "false");
    // if(slack_access){
    //   let navigation= "/integration-sales";
    //     setTimeout(() => {
    //       navigate(navigation);
    //     }, 100);
    //     return
    // }
    setloading(true);
    try {
      const response = await axios({
        // url: `${
        //   process.env.REACT_APP_BASE_SIGNIN_URL
        // }/slack/callback?code=${code}&state=${state}&user_id=${
        //   JSON.parse(localStorage.getItem("login_data"))?.resp_user?.id
        // }`,
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/slack/callback?code=${code}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
      });
      if (!response.data.error) {
        // window.open(response.data.url, "_self");
        localStorage.setItem(
          "slack_access",
          JSON.stringify(response.data?.data)
        );
        let navigation = "/integration-sales";
        setTimeout(() => {
          navigate(navigation);
        }, 100);
      } else {
        localStorage.setItem("slack_access", JSON.stringify(false));
        let navigation = `/integration-sales?error=${response.data.message}`;
        setTimeout(() => {
          navigate(navigation);
        }, 100);
      }
    } catch (error) {
      clog(error);
      if (error.response && error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
    } finally {
      setloading(false);
    }
  };
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    let code = searchParams.get("code");
    let state = searchParams.get("state");
    let error = searchParams.get("error");
    let slack_access = JSON.parse(
      localStorage.getItem("slack_access") || "false"
    );
    if (code && !error) {
      getSlackAccessToken(code, state);
    } else {
      setloading(false);
      localStorage.setItem("slack_access", JSON.stringify(false));
      let navigation = `/integration-sales?error=${error}`;
      setTimeout(() => {
        navigate(navigation);
      }, 100);
    }
  }, []);

  return (
    <div className="flex justify-center items-center h-screen">
      {loading && <Loader />}
    </div>
  );
}

export default SlackCallBackUrl;
